const CATALOG_TOGGLE_MAIN = 'mainPageCatalogMainNewAuto';
const CATALOG_TOGGLE_SIDE = 'mainPageCatalogSaidNewAuto';

import ProductFactory from '../ProductFactory';

export default ProductFactory(CATALOG_TOGGLE_MAIN, CATALOG_TOGGLE_SIDE, 2);
